import { Link } from "react-router-dom";

const planning = [
  ["Plan a week at a time", "Set aside time to prepare announcements, useful tips and updates. A social media content calendar helps you see what is ready and where there are gaps."],
  ["Choose a time for your audience", "Schedule posts for the date and time you choose. Prepare content when it suits your working day, without needing to be online at publication time."],
  ["Review before the rush", "Check captions, media and destinations before scheduling. Simino Social checks media compatibility and reports the result for each destination separately."],
];

export function SocialMediaScheduler() {
  return (
    <>
      <section className="hiw-hero">
        <div className="hiw-hero-inner">
          <p className="hero-badge">AI-Assisted. Human-Led.</p>
          <h1>Social Media Scheduling <span>Without the Daily Rush</span></h1>
          <p className="lede">Plan ahead, schedule your content and keep your social presence consistent without having to stop what you're doing every day to post.</p>
          <div className="hero-cta">
            <Link to="/signin" className="btn-link primary lg">Get started free</Link>
            <Link to="/pricing" className="btn-link lg">Compare scheduling plans</Link>
          </div>
        </div>
      </section>
      <section className="band">
        <div className="band-inner">
          <h2 className="section-title">A consistent presence starts with a manageable plan</h2>
          <p className="lede">For a small business or creator, social media often competes with the rest of the working day. A social media scheduler lets you prepare posts together and spread them across the week. Read <Link to="/resources/why-scheduling">why scheduling matters</Link> for more planning ideas.</p>
          <div className="grid">
            {planning.map(([title, body]) => <article className="feature" key={title}><h3>{title}</h3><p>{body}</p></article>)}
          </div>
        </div>
      </section>
      <section className="band alt">
        <div className="band-inner narrow">
          <h2 className="section-title">Prepare with AI assistance. Publish with human control.</h2>
          <p className="lede">Use Simino Social's brand-aware prompts in your own AI tool to help draft captions. Import the results, check the facts and edit the voice. You choose what is approved, where it goes and when it publishes.</p>
          <p>AI-assisted writing does not replace your judgment or automatically run your accounts. Scheduling sends the content you selected at the time you chose. See <Link to="/how-it-works">how the publishing workflow works</Link>.</p>
        </div>
      </section>
      <section className="band" id="supported-networks">
        <div className="band-inner narrow">
          <h2 className="section-title">Supported social networks</h2>
          <p className="lede">Publish compatible content to Facebook Pages, linked Instagram Business or Creator accounts, and YouTube channels. YouTube destinations are available for video. Account eligibility, permissions and media requirements depend on the network.</p>
          <p>Connect accounts you are authorized to manage, select the destinations for each post and review their individual delivery status.</p>
        </div>
      </section>
      <section className="band alt">
        <div className="band-inner narrow">
          <h2 className="section-title">Frequently asked questions</h2>
          <div className="faq">
            <details><summary>Is scheduling included in the free plan?</summary><p>Scheduling requires a paid plan. You can start with the free plan and compare the current options on our <Link to="/pricing">pricing page</Link>.</p></details>
            <details><summary>Does my browser need to stay open?</summary><p>No. Scheduled publishing runs on the server, so you can close your browser after scheduling.</p></details>
            <details><summary>Is publication guaranteed?</summary><p>No. Publication depends on valid account permissions, platform availability and media rules. Each destination reports its own outcome so you can see what needs attention.</p></details>
            <details><summary>Does AI publish without my decision?</summary><p>No. You review and select the content, destinations and publishing time. AI assistance helps with preparation.</p></details>
          </div>
        </div>
      </section>
      <section className="hiw-cta">
        <div>
          <p className="eyebrow">Make room for the rest of your work</p>
          <h2>Prepare your next week of social content.</h2>
          <p>Explore <Link to="/">Simino Social's social media management platform</Link> or start preparing your first post.</p>
          <Link to="/signin" className="btn-link primary lg">Get started free</Link>
        </div>
      </section>
    </>
  );
}
